// updateNotifier.js
// Detecta cuando hay una versión nueva de la app desplegada (un sw.js nuevo)
// mientras la pestaña sigue abierta con el código viejo en memoria, y avisa
// mediante un pequeño banner con botón "Actualizar" (<UpdateBanner />, montado
// en App.jsx) — NUNCA recarga sola, para no perder algo que el usuario esté
// rellenando en una pantalla sin borrador en localStorage.
//
// El sw.js ya hace skipWaiting() + clients.claim() en cuanto se instala una
// versión nueva, así que "controllerchange" es la señal fiable de "ya hay
// otra versión activa, pero esta pestaña sigue corriendo la vieja".

let listeners = [];
let visible = false;

function emit() {
  listeners.forEach((fn) => fn(visible));
}

export function subscribe(fn) {
  listeners.push(fn);
  fn(visible);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}

export function actualizarAhora() {
  window.location.reload();
}

export function descartarAviso() {
  visible = false;
  emit();
}

// En vez de un timer ciego, se comprueba cuando pasa algo que de verdad
// justifica mirar: la pestaña vuelve a primer plano (alguien reabre la app
// tras tenerla en segundo plano o cambia de pestaña y vuelve) — es justo el
// momento en que tiene sentido preguntar, y cubre el caso real de dejar la
// app de fondo días enteros sin cerrarla. INTERVALO_RESPALDO_MS es solo un
// colchón por si alguien deja la pantalla visible y en primer plano sin
// tocarla durante horas seguidas (visibilitychange no dispararía ahí).
const INTERVALO_RESPALDO_MS = 2 * 60 * 60 * 1000; // 2h, solo de respaldo

// Empujón puntual para un cambio concreto: cuando se necesita que las
// asistentas que ya tengan la app abierta reciban un fix YA, sin esperar a
// que pulsen "Actualizar" en el banner. Cambiar este id en cada ocasión que
// haga falta repetirlo (cada valor nuevo se aplica una sola vez por
// dispositivo/usuario, nunca más — el resto de actualizaciones siguen
// funcionando como siempre, con el banner de "Actualizar").
const RECARGA_FORZADA_ID = "reporte_hoy_asistenta_2026_09_21";

function comprobarRecargaForzadaAsistenta() {
  try {
    const tipo = (JSON.parse(localStorage.getItem("user") || "{}") || {}).tipo || "";
    if (tipo !== "asistenta") return false;
    const key = "recarga_forzada_" + RECARGA_FORZADA_ID;
    if (localStorage.getItem(key)) return false;
    localStorage.setItem(key, "1");
    actualizarAhora();
    return true;
  } catch (e) {
    return false;
  }
}

export function initUpdateNotifier() {
  if (!("serviceWorker" in navigator)) return;

  // Si la pestaña YA estaba controlada por un service worker al cargar, un
  // "controllerchange" posterior es una actualización real. Si no lo estaba
  // (primera instalación del SW en este navegador), ese mismo evento puede
  // saltar sin que haya nada nuevo que avisar — no es una actualización.
  const yaEstabaControlada = !!navigator.serviceWorker.controller;

  navigator.serviceWorker
    .register("/sw.js")
    .then((reg) => {
      const comprobar = () => reg.update().catch(() => {});

      // Momento natural para comprobar: la pestaña vuelve a primer plano.
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") comprobar();
      });
      // Complemento para casos que visibilitychange no cubre bien en algunos
      // navegadores/PWA (p.ej. volver de otra app en ciertos Android WebView).
      window.addEventListener("focus", comprobar);

      setInterval(comprobar, INTERVALO_RESPALDO_MS);
    })
    .catch(() => {});

  let yaAvisado = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!yaEstabaControlada || yaAvisado) return;
    yaAvisado = true;

    if (comprobarRecargaForzadaAsistenta()) return;

    visible = true;
    emit();
  });
}
